export class LnkAttributsObjets {
    public id_attribut: number;
    public id_objet: number;
    public valeur: string;
    public valeur_date: Date;
    public valeur_bool: number;
    public valeur_string: string;
}